import React, { useState } from "react";
import { MailOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { Tooltip, message } from "antd";
import { fetchTimeSheet, resendEmail } from "../attendanceOverviewThunk";

const ActionOptionsForTimeSheet = ({ rowData, onFilters }) => {
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(false);

  const handleResend = async () => {
    try {
      setIsDisabled(true);
      const data = { id: rowData.id };

      const resultAction = await dispatch(resendEmail(data));

      if (resendEmail.fulfilled.match(resultAction)) {
        message.success(
          resultAction.payload?.message || "Email sent successfully!"
        );

        // ✅ Fetch all records again
        await dispatch(fetchTimeSheet(onFilters)).unwrap();
      } else {
        message.warning(
          resultAction.payload?.message ||
            "Failed to resend email. Please try again."
        );
      }
    } catch (error) {
      message.error("Something went wrong while sending the email.");
    } finally {
      setIsDisabled(false);
    }
  };

  return (
    <div
      style={{
        textAlign: "right",
        display: "flex",
        gap: "0.5rem",
        justifyContent: "end",
      }}
    >
      {!isDisabled && (
        <Tooltip title="Resend Email">
          <MailOutlined
            style={{
              fontSize: 20,
              cursor: "pointer",
              color: "#1890ff",
            }}
            onClick={handleResend}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default ActionOptionsForTimeSheet;
